/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolArchitectureIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-architecture"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.5 11.45L8.6 19.35Q8.57 19.43 8.45 19.6L7.35 20.63Q7.05 20.9 6.69 20.77Q6.33 20.65 6.28 20.23L6.13 18.75Q6.13 18.75 6.15 18.45L9.15 10.15Q9.65 10.6 10.25 10.95Q10.85 11.3 11.5 11.45ZM12 11Q12 11 11.3 11Q10.6 11 9.63 10.03Q8.65 9.05 8.65 7.65Q8.65 6.63 9.18 5.8Q9.7 4.97 10.65 4.55L10.65 3.88Q10.65 3.33 11.04 2.94Q11.43 2.55 11.97 2.55Q12.53 2.55 12.91 2.94Q13.3 3.33 13.3 3.88L13.3 4.55Q14.25 4.97 14.8 5.8Q15.35 6.63 15.35 7.65Q15.35 9.05 14.38 10.03Q13.4 11 12 11ZM12 8.35Q12 8.35 12.15 8.35Q12.3 8.35 12.5 8.15Q12.7 7.95 12.7 7.65Q12.7 7.35 12.5 7.15Q12.3 6.95 12 6.95Q11.7 6.95 11.5 7.15Q11.3 7.35 11.3 7.65Q11.3 7.95 11.5 8.15Q11.7 8.35 12 8.35ZM12.5 11.45Q13.15 11.3 13.75 10.95Q14.35 10.6 14.85 10.15L17.85 18.45Q17.88 18.55 17.88 18.75L17.73 20.23Q17.68 20.65 17.31 20.77Q16.95 20.9 16.65 20.63L15.55 19.6Q15.53 19.57 15.4 19.35Z" fill={color} />
    </svg>
  );
}
